import axios from 'axios';

const url = '/api/v1/tipdirect/tour-photos';

/**
 * Card 305 — the guide's tour photo session, from the web app.
 *
 * Auth here is the same-origin session cookie the whole web app already uses;
 * there is no Authorization header anywhere in this codebase. That makes these
 * calls simpler than the mobile app's, which carries an x-api-key.
 *
 * The endpoints themselves are shared with the mobile app and deliberately
 * carry no role check, so a logged-in guide is already authorised.
 */

// Returns { gallery: null } when there is no open session — the normal state at
// the start of a tour and immediately after "new tour".
export const fetchCurrentGallery = () =>
  axios.get(`${url}/current`).then(res => res.data.data);

// Seals the session. Once sealed the guide can no longer see those photos; the
// access loss between tours is deliberate and is a safeguard in the LIA.
export const sealCurrentGallery = () =>
  axios.post(`${url}/seal`).then(res => res.data.data);

/**
 * Upload one photo, reporting progress.
 *
 * One photo per request on purpose: a failure loses that photo and not the
 * other seven, and it is the only way to show honest per-photo progress.
 *
 * axios exposes onUploadProgress, so unlike the mobile app this does not need a
 * hand-rolled XMLHttpRequest.
 */
export const uploadTourPhoto = ({ file, onProgress }) => {
  const data = new FormData();
  data.append('files', file);

  return axios
    .post(url, data, {
      onUploadProgress: event => {
        if (onProgress && event.total > 0) {
          onProgress(event.loaded / event.total);
        }
      }
    })
    .then(res => {
      const payload = res.data.data;

      // The server refuses a silently-rejected file (wrong type, too large,
      // gallery already full) in a `rejected` array rather than a non-2xx, so
      // a 200 alone does not mean the photo landed.
      if (payload?.rejected?.length > 0 && payload?.photos?.length === 0) {
        throw new Error(payload.rejected[0].reason || 'upload_rejected');
      }

      return payload;
    });
};
